<template>
    <div class="forget_container">
        <div class="forget">
            <div class="forget_title">
                <span style="font-size: 20px;font-weight: 600;">{{$t('login.resetPassword')}}</span>
                <span style="color: #386AEA;cursor: pointer;font-weight: 600;" @click="tologin">{{$t('login.returnToLogin')}}</span>
            </div>
            <div v-if="active <= 3">
                <div class="forget_step">
                    <el-steps align-center :active="active" finish-status="success">
                        <el-step :class="{ 'stepone': active == 1 }" :title="$t('login.verifyAccount')" />
                        <el-step :title="$t('login.setNewPsw')" />
                        <el-step :title="$t('login.resetPswSuccess')" />
                    </el-steps>
                </div>
                <div class="forget_form">
                    <el-form v-if="active == 1" ref="form" :model="loginForm" :rules="rules" label-width="80px">
                        <el-form-item prop="mobile">
                            <el-input :placeholder="$t('login.enterAccount')" v-model.trim="loginForm.mobile">
                                <template #prefix>
                                    <img src="@/assets/image/mobile.svg" alt="">
                                </template>
                                <template #suffix>
                                    <img @click="loginForm.mobile = ''" style="cursor: pointer;"
                                        v-if="loginForm.mobile.length" src="@/assets/image/clear.svg" alt="">
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="smsCode">
                            <el-input :placeholder="$t('register.verificationCode')" v-model.trim="loginForm.smsCode">
                                <template #prefix>
                                    <img src="@/assets/image/code.svg" alt="">
                                </template>
                                <template #suffix>
                                    <span @click.stop="sendCode" v-if="!isSend"
                                        style="color: #386AEA; cursor: pointer;font-size:16px;">{{$t('register.getVerificationCode')}}</span>
                                    <span v-else style="color: #6a6a6a; cursor: pointer;">{{locale==='en'? $t("register.resendCodeTips")+codeTime+ 's': codeTime + $t("register.resendCodeTips") }}</span>
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <el-form v-show="active == 2 || active == 3" ref="form1" :model="passwordForm" :rules="passwordrules"
                        label-width="80px">
                        <el-form-item prop="password">
                            <el-input :type="islook ? 'text' : 'password'" :placeholder="$t('login.setPassword')"
                                v-model.trim="passwordForm.password">
                                <template #prefix>
                                    <img src="@/assets/image/password.svg" alt="">
                                </template>
                                <template #suffix>
                                    <div @click="islook = !islook">
                                        <img v-if="!islook" src="@/assets/image/hide.svg" alt="">
                                        <img v-else src="@/assets/image/look.svg" alt="">
                                    </div>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="confirmPassword">
                            <el-input :type="islook1 ? 'text' : 'password'" :placeholder="$t('login.confirmPsw')"
                                v-model.trim="passwordForm.confirmPassword">
                                <template #prefix>
                                    <img src="@/assets/image/conformPas.svg" alt="">
                                </template>
                                <template #suffix>
                                    <div @click="islook1 = !islook1">
                                        <img v-if="!islook1" src="@/assets/image/hide.svg" alt="">
                                        <img v-else src="@/assets/image/look.svg" alt="">
                                    </div>
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <!-- <div style="display: flex;justify-content: space-between;margin: 67px 0px 16px;">
                <div>
                    <span style="margin-right: 16px;">还没有账号?</span>
                    <span class="pinpai">立即注册</span>
                </div>
                <div @click="toForgetPassword" class="pinpai">忘记登录密码</div>
            </div> -->
                <div class="forget_form" style="margin-top: 40px;">
                    <el-button class="loginbtn" color="#386AEA" type="primary" @click="handleStep"><span
                            style="color: #fff;font-weight: 500;">{{$t('login.nextStep')}}</span></el-button>
                </div>
            </div>
            <div style="margin: 0 auto; width: 400px; margin-top: 103px;" v-else>
                <div class="center">
                    <img style="width: 150px;height: 150px;" src="@/assets/image/sucess.png" alt="">
                </div>
                <div style="font-size: 24px; font-weight: 500;" class="center">
                    {{$t('login.resetPswSuccess')}}  
                </div>
                <div style="margin: 8px 0px 64px;color: #fff; opacity: 0.8;" class="center">
                    {{$t('register.keepAccountSafe')}}
                </div>
                <el-button class="registerbtn" color="#386AEA" type="primary" @click="tofind">{{$t('register.enterHomepage')}}</el-button>
            </div>
        </div>
    </div>
</template>
  
<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { validateMobileOrEmail, validateEmail, validatePassword, validateCode } from '@/utils/common.js'
import { resetPassword, getcode } from '@/api/common.js'
import {Encrypt} from '@/utils/crypt.util.js'
import { useI18n } from "vue-i18n";
const { locale, t } = useI18n();

const form = ref(null)
const form1 = ref(null)
const router = useRouter()
const active = ref(1)//步骤条
const isSend = ref(false)//是否发送验证码
const codeTime = ref(60) //验证码倒计时
let timerId;//定义一个变量存储定时器 
const islook = ref(false)//，密码图标显示
const islook1 = ref(false)
const loginForm = ref({
    mobile: '',
    smsCode: ''
})
const passwordForm = ref({
    password: '',
    confirmPassword: ''
})
//验证两次密码是否一样
const isSamePassword = (rule, value, callback) => {
    console.log(value !== passwordForm.value.password);
    if (value !== passwordForm.value.password) {
        callback(new Error(t("register.pswnomatch")))
    } else {
        callback()
    }
}
const rules = ref({
    mobile: [
        { required: true, message: t("login.writeAccount"), trigger: 'blur' },
        { validator: locale.value === 'en'? validateEmail:validateMobileOrEmail, trigger: 'blur' }
    ],
    smsCode: [
        { required: true, message: t("register.pleaseEnterVerificationCode"), trigger: 'blur' }, 
        { validator: validateCode, trigger: 'blur' }
    ]
})
const passwordrules = ref({
    password: [
        { required: true, message: t("register.pleaseEnterPsw"), trigger: 'blur' },
        { validator: validatePassword, trigger: 'blur' },

    ],
    confirmPassword: [
        { required: true, message: t("register.pleaseConfirmPsw"), trigger: 'blur' },
        { validator: validatePassword, trigger: 'blur' },
        { validator: isSamePassword, trigger: 'blur' },
    ]
})
//跳转登录页
const tologin = () => {
    router.push('/login')
}
// 发送验证码
const sendCode = () => {
    form.value.validateField('mobile',err=>{console.log(err);})//仅做报错提示
    if (isSend.value || !loginForm.value.mobile) return
    isSend.value = true
    let data = {
        mobile: loginForm.value.mobile,
        type: loginForm.value.mobile.includes('@') ? 1 : 0 // 0:手机号 1：邮箱
    }

    // console.log(data)
    // return
    getcode(data).then(res => {
        console.log(res);
        if (res.code === 200) {
            ElMessage({
                message: t("register.codeSend"),
                customClass: "custom-message1",
            });
        }
    })
    timerId = setInterval(() => {
        codeTime.value = codeTime.value - 1
        if (codeTime.value == 0) {
            clearInterval(timerId)
            isSend.value = false
            codeTime.value = 60
        }
    }, 1000)
}
//处理下一步
const handleStep = () => {
    if (active.value == 1) {
        form.value.validate((value) => {
            if (value) {
                active.value = active.value + 1
            }
        })
    } else if (active.value == 2) {
        form1.value.validate((value) => {
            if (value) {
                // active.value = active.value + 1
                //重置密码
                // console.log({...loginForm.value,...passwordForm.value});
                resetPassword({ ...loginForm.value, password:Encrypt(passwordForm.value.password), confirmPassword:Encrypt(passwordForm.value.confirmPassword) }).then(res => {
                    console.log('ressssss:',res);
                    if (res.code === 200) {
                        active.value = active.value + 2
                    }else{
                        // 这里设置新密码之后不通过返回第一步是因为在第二步信息填写完之后一起发给接口校验验证码，验证码有效时间1分钟
                        active.value = 1
                        passwordForm.value.password = ''
                        passwordForm.value.confirmPassword = ''

                    }
                }).catch(err => { console.log(err); })
            }
        })
    }

}
//进入首页
const tofind = () => {
    router.push('/home/find')
}
</script>
  
<style scoped lang="scss">

::v-deep  .el-button:hover {
    background-color: #325FD3;
  border-color: #325FD3;
}
::v-deep .el-button:focus{
  background-color:#386AEA;
  border-color: #386AEA;
}
::v-deep .el-form-item {
    margin-bottom: 16px;
}

::v-deep .el-form-item.is-error {
    margin-bottom: 48px;
}

::v-deep .el-form-item.is-error .el-input__wrapper {
    box-shadow: 0 0 0 0.5px #E70A27 inset !important;
}
::v-deep .el-input__wrapper{
  box-shadow: 0 0 0 0.5px #ffffff32 inset !important;
}
::v-deep .el-form-item__error {
    color: #E70A27;
    line-height: 24px;
    padding-top: 0px;
    margin: 8px 0px 16px;
}

::v-deep .el-input__inner::placeholder {
    color: #fff;
    opacity: 0.4;
}

::v-deep .el-input__inner {
    color: #fff;
    caret-color: #386AEA;
    font-size: 16px;

}

::v-deep .el-step__title.is-wait {
    color: #fff;
}

@media (max-width:1200px) {
    .forget_container {
        .forget {
            width: 800px !important;

            .forget_step {
                width: 830px !important;
            }
        }
    }
}

.registerbtn {
    width: 100%;
    height: 64px;
    font-size: 20px;
}

.center {
    text-align: center;
}

.pinpai {
    color: #386AEA;
    cursor: pointer;
}

div,
span {
    color: #fff;
}

.forget_container {
    min-height: 100vh;
    background-color: #0A0A0A;
    display: flex;
    align-items: center;

    .forget {
        .forget_step {
            width: 988px;
            margin: 0 auto;
            margin-left: -50%;
            transform: translateX(46%);
            margin-top: 66px;
            margin-bottom: 56px;
        }

        width: 945px;
        // min-height: 604px;
        margin: 0 auto;
        background-color: #1D1D1D;
        border-radius: 4px;
        padding-bottom: 115px;

        .forget_form {
            width: 400px;
            margin: 0 auto;
            // padding-left: 273px;
            // padding-right: 272px;
        }

        .stepone {
            ::v-deep .el-step__line-inner {
                width: 50% !important;
                border-width: 1px !important;
            }
        }

        ::v-deep .el-step__line {
            background-color: #585858;
            // top: 7px;
        }

        ::v-deep .el-step__head.is-success {
            color: #386AEA;
            border-color: #386AEA;
        }

        ::v-deep .el-step__title.is-success,
        ::v-deep .el-step__title.is-process {
            color: #fff;
            font-weight: 400;
        }

        ::v-deep .el-step__icon {
            width: 12px;
            height: 12px;
            background-color: #386AEA;
            border: none;

            svg,
            .el-step__icon-inner {
                display: none;
            }
        }

        .forget_title {
            display: flex;
            justify-content: space-between;
            padding: 32px 40px 0px;
        }

        .loginbtn {
            width: 100%;
            height: 64px;
            font-size: 20px;
        }

        ::v-deep .el-form-item__content {
            margin-left: 0px !important;
        }

        ::v-deep .el-form-item__content .el-input__wrapper {
            background-color: #292929;
            box-shadow: none;
            height: 64px;
            padding: 1px 20px;
        }

        ::v-deep .el-input__prefix-inner>:last-child {
            margin-right: 20px;
        }

        ::v-deep .el-form-item.is-error .el-input__wrapper {
            box-shadow: 0 0 0 0.5px #fff inset;
        }

        .logo {
            width: 128px;
            height: 128px;
            border-radius: 26px;
            background-color: #191919;
            margin: 0 auto 56px;
            padding: 36px 16px;
        }
    }
}
</style>